import { concatClasses } from "../../../helpers/concatClasses/index.js";
const getPaginationWrapperClasses = (props) => {
  const classes = ["pagination-wrapper", "flex", "gap-12", "border-b-neutral-300", "relative"];
  if (props.dsf_placement === "vertical") {
    classes.push("flex-col", "min-h-full", "ml-8");
  } else {
    classes.push("flex-row", "items-end", "min-w-full");
  }
  return concatClasses(classes);
};
const getRailwayClasses = ({ dsf_placement }) => {
  const classes = ["absolute", "bg-neutral-200", "-z-2"];
  if (dsf_placement === "vertical") {
    classes.push(...["left-0", "-mr-1", "w-1", "h-full"]);
  } else {
    classes.push(...["bottom-0", "-mt-1", "h-1", "w-full"]);
  }
  return concatClasses(classes);
};
export {
  getPaginationWrapperClasses,
  getRailwayClasses
};
